import React from "react";
import ButtonAtm from "../../atoms/ButtonAtm";
function Button(_ref) {
  var to = _ref.to,
    href = _ref.href,
    title = _ref.title,
    rel = _ref.rel,
    onClick = _ref.onClick,
    text = _ref.text,
    isLoading = _ref.isLoading;
  return /*#__PURE__*/React.createElement(ButtonAtm, {
    color: "primary",
    to: to,
    href: href,
    title: title,
    onClick: onClick,
    rel: rel,
    isLoading: isLoading,
    "data-test-id": "add-button"
  }, text);
}
export default Button;